module.exports = __webpack_public_path__ + "static/fis-6626e38df29fe4935be001c95992e312.jpg";